import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BaseDialog, Dialog } from '@lf-web-components/lf-dialog-library';
import { EventSystemService } from '@lf-web-components/lf-event-library';
import { NoopScrollStrategy } from '@angular/cdk/overlay';

@Component({
  selector: 'lf-import-local-dialog',
  templateUrl: './import-local-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./import-local-dialog.component.css', '../global-styles.css', '../lf-button-styles.css', '../lf-custom-mat-styles.css']
})
@Dialog({
  name: 'ImportLocalDialog',
  width: '700px',
  height: '400px',
  dialogConfig: {
    panelClass: 'lf-import-local-dialog',
    scrollStrategy: new NoopScrollStrategy()
  }
})
export class ImportLocalDialogComponent extends BaseDialog implements OnInit {
  @ViewChild('importIframe') iframe: any;
  isLoading: boolean;
  url: SafeResourceUrl;
  mutationObserver: MutationObserver;

  constructor(eventSystem: EventSystemService,
    dialogRef: MatDialogRef<BaseDialog>,
    @Inject(MAT_DIALOG_DATA) protected data: any,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef) { 
    super(eventSystem, dialogRef, data);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.importUrl);
  }
  
  ngAfterViewInit() {
    const nativeElement = this.iframe.nativeElement;
    if ((nativeElement.contentDocument || nativeElement.contentWindow.document).readyState === 'complete'){
      nativeElement.onload = this.onLoad.bind(this);
    } else {
      if (nativeElement.addEventListener) {
        nativeElement.addEventListener('load', this.onLoad.bind(this), true);
      } else if (nativeElement.attachEvent) {
        nativeElement.attachEvent('onload', this.onLoad.bind(this));
      }
    }
  }

  onLoad() {
    let self = this;
    this.isLoading = false;
    const nativeElement = this.iframe.nativeElement;
    const dialogDimensions = {
      min: {width: 350, height: 200},
      max: {width: 800, height: 800},
      conflictDialogVersion: {width: 640, height: 600},
      conflictDialogDefault: {width: 640, height: 400}
    }

    if (nativeElement.contentDocument && nativeElement.contentDocument.readyState === 'complete') {
      let errorMsg = nativeElement.contentDocument.getElementById('ErrMsg');
      if (!errorMsg) {
        nativeElement.contentDocument.body.style.backgroundColor = "transparent";
      }

      const config = { attributes: true, childList: true, subtree: true, characterData: true};

      let callback = function(mutationList){
    
        let convertPixel = function(size: number){
          return size.toString() + "px";
        }

        let resizeDialog = function() {
          self.mutationObserver.disconnect();
          const iframe = self.iframe.nativeElement.contentDocument;
          const container = iframe.body;

          let importDialog = iframe.getElementById('importDialogTab');
          let conflictDialog = iframe.getElementById('newVersionLabel');
          let modalDialog = iframe.getElementsByClassName('modal-dialog');
          let modalBackdrop = iframe.getElementsByClassName('modal-backdrop in');
          let cloudImportSection = iframe.getElementById('BodyPlaceHolder_cloudImportSection');
        
          if (modalDialog && modalDialog.length > 0){

            if (modalBackdrop && modalBackdrop.length > 0){
              modalBackdrop[0].style.backgroundColor = "transparent";
            }

            if (cloudImportSection){
              cloudImportSection.style.display = "none";
            }

            let width = modalDialog[0].offsetWidth + 50 > dialogDimensions["max"]["width"] ? dialogDimensions["max"]["width"] : modalDialog[0].offsetWidth + 50;
            let height = modalDialog[0].offsetHeight + 50 > dialogDimensions["max"]["height"] ? dialogDimensions["max"]["height"] : modalDialog[0].offsetHeight + 50;
    
            width = width < dialogDimensions["min"]["width"] ?  dialogDimensions["min"]["width"] : width;
            height = height <  dialogDimensions["min"]["height"] ?  dialogDimensions["min"]["height"] : height;

            if (conflictDialog){
              conflictDialog.children[0].checked ? 
                self.dialogRef.updateSize(convertPixel(dialogDimensions["conflictDialogVersion"]["width"]), convertPixel(dialogDimensions["conflictDialogVersion"]["height"])) :
                self.dialogRef.updateSize(convertPixel(dialogDimensions["conflictDialogDefault"]["width"]), convertPixel(dialogDimensions["conflictDialogDefault"]["height"]));
            } else if (importDialog){
              self.dialogRef.updateSize(convertPixel(dialogDimensions["max"]["width"]), convertPixel(dialogDimensions["max"]["height"]));
            } else {
              self.dialogRef.updateSize(convertPixel(width), convertPixel(height));
            }

            self.cd.detectChanges();
          }

          self.mutationObserver.observe(container, config);
        }
    
        for(const mutation of mutationList) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            resizeDialog();
          }
        }
      }

      this.mutationObserver = new MutationObserver(callback);
      this.mutationObserver.observe(nativeElement.contentDocument.body, config);
    }
  }

  onClose(){
    this.dialogRef.close();
  }

  ngOnDestroy() {
    if (this.mutationObserver){
      this.mutationObserver.disconnect()
    }
  }
}